export default __webpack_public_path__ + "static/media/tourlyTwitter-600x314.895c15f7.jpg";